// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Checnovskaya <anastasia.chesnovskaya@celadon.ae>
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';

import { Loader } from '../../../../../../components';
import { getOrder } from '../OrderFull/store/selectors';
import * as orderDetailsActions from '../OrderFull/store/actions';
import ArrangeCollectionView from './ArrangeCollectionView';
import styles from './styles';


class ArrangeCollection extends Component {
  state = {};

  componentDidMount() {
    const { history } = this.props;
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('loggedID');
    const orderId = history.location.state.id;
    this.props.requestOrder({ token, id, orderId });
  }

  componentWillUnmount() {
    this.props.resetOrder();
  }

  render() {
    const { classes, order } = this.props;
    return (
      order
        ? <ArrangeCollectionView order={this.props.order} />
        : <div className={classes.loaderContainer}><Loader /></div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    order: getOrder(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestOrder: data => dispatch(orderDetailsActions.requestOrderDetails(data)),
    resetOrder: () => dispatch(orderDetailsActions.resetOrder()),
  };
};

ArrangeCollection.propTypes = {
  history: PropTypes.object,
  classes: PropTypes.object,
  order: PropTypes.object,
  requestOrder: PropTypes.func,
  resetOrder: PropTypes.func,
};

ArrangeCollection.defaultProps = {
  history: {},
  classes: {},
  order: null,
  requestOrder: () => { },
  resetOrder: () => { },
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ArrangeCollection));
